import {
    SidebarMenuSubButton,
    SidebarMenuSubItem,
} from '@/ui/design-system/components/ui/sidebar';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { FiMoreHorizontal } from 'react-icons/fi';
import Link from '../Link';
import useCountryParam from 'utils/hooks/useCountryParam';
import { useState } from 'react';
import { parentNameFilterKeyForRouteSlug } from 'utils/dataSources';

const relatedCategoriesPath =
    '/explore/related-categories/:dataSource(tiktok|google|instagram)?/trends/:categoryId?';

const items = [
    { label: 'Ingredients', relatedCategoryQueryParam: 'ingredients' },
    { label: 'Product Format', relatedCategoryQueryParam: 'product format' },
    { label: 'Benefits', relatedCategoryQueryParam: 'benefits' },
    { label: 'Concerns', relatedCategoryQueryParam: 'concerns' },
    { label: 'Retailers', relatedCategoryQueryParam: 'retailers' },
    { label: 'Demographics', relatedCategoryQueryParam: 'demographics' },
    { label: 'Colors & Prints', relatedCategoryQueryParam: 'colors & prints' },
];

function SidebarRelatedCategories() {
    const { mutateToWithCountryParam } = useCountryParam();
    const [expanded, setExpanded] = useState(false);
    const location = useLocation();
    const match = useRouteMatch(relatedCategoriesPath);

    const searchParams = new URLSearchParams(location.search);
    const categoryId = match?.params?.categoryId;
    const dataSource = match?.params?.dataSource;
    const filterParamPrefix = 'relatedCategories.';
    const queryParamKey = `${filterParamPrefix}${parentNameFilterKeyForRouteSlug(dataSource)}`;
    const parentNameParam = searchParams.get(queryParamKey);
    const isActive = match && parentNameParam;

    const getUrl = (parentName) => {
        const path = `/explore/related-categories${dataSource ? `/${dataSource}` : ''}/trends${categoryId ? `/${categoryId}` : ''}`;
        const search = new URLSearchParams({
            [queryParamKey]: parentName,
        }).toString();
        return mutateToWithCountryParam(`${path}?${search}`);
    };

    return (
        <>
            <SidebarMenuSubItem>
                <SidebarMenuSubButton
                    asChild
                    isActive={!!isActive && parentNameParam === 'ingredients'}
                >
                    <Link
                        to={getUrl('ingredients')}
                        onClick={() => setExpanded(false)}
                        mixpanelContext="Related Categories Ingredients"
                    >
                        <span>Ingredients</span>
                    </Link>
                </SidebarMenuSubButton>
            </SidebarMenuSubItem>

            {!expanded && (
                <SidebarMenuSubItem>
                    <SidebarMenuSubButton
                        isActive={
                            !!isActive && parentNameParam !== 'ingredients'
                        }
                        onClick={() => setExpanded(true)}
                    >
                        <span className="text-xs text-muted-foreground">
                            More
                        </span>
                        <FiMoreHorizontal className="ml-auto" />
                    </SidebarMenuSubButton>
                </SidebarMenuSubItem>
            )}

            {expanded && (
                <>
                    {items
                        .slice(1)
                        .map(({ label, relatedCategoryQueryParam }) => (
                            <SidebarMenuSubItem key={relatedCategoryQueryParam}>
                                <SidebarMenuSubButton
                                    asChild
                                    isActive={
                                        !!isActive &&
                                        parentNameParam ===
                                            relatedCategoryQueryParam
                                    }
                                >
                                    <Link
                                        to={getUrl(relatedCategoryQueryParam)}
                                        onClick={() => setExpanded(false)}
                                        mixpanelContext={`Related Categories ${label}`}
                                    >
                                        <span>{label}</span>
                                    </Link>
                                </SidebarMenuSubButton>
                            </SidebarMenuSubItem>
                        ))}
                    <SidebarMenuSubItem>
                        <SidebarMenuSubButton
                            onClick={() => setExpanded(false)}
                        >
                            <span className="text-xs text-muted-foreground">
                                Less
                            </span>
                        </SidebarMenuSubButton>
                    </SidebarMenuSubItem>
                </>
            )}
        </>
    );
}

export default SidebarRelatedCategories;
